// extracted by mini-css-extract-plugin
export var adjacentSlide = "_q1-9";
export var arrowButtonContainer = "_q1-5";
export var arrowButtonIcon = "_q1-6";
export var carouselArrowButton = "_q1-2";
export var carouselElementContainer = "_q1-1";
export var currentSlide = "_q1-8";
export var left = "_q1-3";
export var otherSlide = "_q1-a";
export var productCarouselContainer = "_q1-0";
export var right = "_q1-4";
export var sliderOverflow = "_q1-7";